import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=7148da64&scoped=true&"
import script from "./OverviewView.vue?vue&type=script&lang=js&"
export * from "./OverviewView.vue?vue&type=script&lang=js&"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=7148da64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148da64",
  null
  
)

export default component.exports